import {
  CREATE_BATCH_REQUEST,
  CREATE_BATCH_SUCCESS,
  CREATE_BATCH_FAILURE,
  FETCH_BATCHES_REQUEST,
  FETCH_BATCHES_SUCCESS,
  FETCH_BATCHES_FAILURE,
  DELETE_BATCH_SUCCESS,
  DELETE_BATCH_FAILURE,
  UPDATE_BATCH_SUCCESS,
  UPDATE_BATCH_FAILURE,
  ASSIGN_BATCH_SUCCESS,
  ASSIGN_BATCH_FAILURE,
} from '../actions/batchActions';

const initialState = {
  batches: [],
  loading: false,
  error: null,
};

export default function batchReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_BATCH_REQUEST:
    case FETCH_BATCHES_REQUEST:
      return { ...state, loading: true, error: null };
      
    case CREATE_BATCH_SUCCESS:
      return { ...state, loading: false, batches: [...state.batches, action.payload] };

    case FETCH_BATCHES_SUCCESS:
      return { ...state, loading: false, batches: action.payload };

    case DELETE_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        batches: state.batches.filter((batch) => batch.id !== action.payload),
      };

    case UPDATE_BATCH_SUCCESS:
    case ASSIGN_BATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        batches: state.batches.map((batch) =>
          batch.id === action.payload.id ? action.payload : batch
        ),
      };

    case CREATE_BATCH_FAILURE:
    case FETCH_BATCHES_FAILURE:
    case DELETE_BATCH_FAILURE:
    case UPDATE_BATCH_FAILURE:
    case ASSIGN_BATCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
